import { useDebounceCallback } from "@opensea/ui-kit/hooks"
import { useSound } from "use-sound"
import { Sound, soundOpts, useVolume } from "@/stores/use-volume-store"

export { Sound }

export function usePlaySound(sound: Sound) {
  const { volume } = useVolume()

  const options = soundOpts(volume)

  const [playSound] = useSound(sound, options)

  // Debounce sound playback to prevent rapid repeated playback
  const debouncedPlaySound = useDebounceCallback(
    (...args: Parameters<typeof playSound>) => {
      if (volume === "off") {
        return Promise.resolve()
      }
      return playSound(...args)
    },
    300, // 300ms debounce delay
    { leading: true, trailing: false }, // Trigger immediately on first call, prevent trailing call
  )

  return [debouncedPlaySound] as const
}
